import { Grid } from "@mui/material";
import { useFormContext } from "react-hook-form";
import { BorderedFormGrid } from "../../../../Forms/BorderedFormGrid";
import { TTProtection } from "../../TTProtection";
import { TtProtectionFilterProps } from "./TtProtectionFilterProps";
import { RHFAutoCompleteWithDebouncedFetch } from "./MultiSelectMenues/RHFAutoCompleteWithDebouncedFetch";
import { ttProtectionFilterUrls } from "../../../../URL/ApplicationUrls";
import { TtProtectionMultiSelect } from "./MultiSelectMenues/TtProtectionMultiSelect";

export const OriginRegionFilters = ({ selectedFilters }: TtProtectionFilterProps) => {
  const { control } = useFormContext<TTProtection>();

  return (
    <BorderedFormGrid subformName="Origin Region">
      <Grid item xs={12}>
        <TtProtectionMultiSelect
          name="TtProtectionFilters.SupplierCountryIds"
          control={control}
          label="Supplier Country"
          apiUrl={ttProtectionFilterUrls.supplierCountries}
          errorMessage="An error occurred when retrieving the Supplier Countries"
        />
      </Grid>
      <Grid item xs={12}>
        <TtProtectionMultiSelect
          name="TtProtectionFilters.SupplierRegions"
          control={control}
          label="Supplier Regions"
          apiUrl={ttProtectionFilterUrls.supplierRegions}
          errorMessage="An error occurred when retrieving the Supplier Regions"
        />
      </Grid>
      <Grid item xs={12}>
        <RHFAutoCompleteWithDebouncedFetch
          name="TtProtectionFilters.SupplierZipAreas"
          control={control}
          label="Supplier Postcode Area"
          initialFilters={selectedFilters?.SupplierZipAreas}
          apiUrl={ttProtectionFilterUrls.supplierPostcodeAreas}
          errorMessage="An error occurred when retrieving the Supplier Postcode Areas"
        />
      </Grid>
      <Grid item xs={12}>
        <RHFAutoCompleteWithDebouncedFetch
          name="TtProtectionFilters.SupplierGsdbs"
          control={control}
          label="Supplier GSDB"
          initialFilters={selectedFilters?.SupplierGsdbs}
          apiUrl={ttProtectionFilterUrls.suppliers}
          errorMessage="An error occurred when retrieving the Supplier GSDBs"
        />
      </Grid>
    </BorderedFormGrid>
  );
};
